














































































































import { Component, Vue } from "vue-property-decorator";
import getCountryFlagUrl from "@/utils/helpers/getCountryFlagUrl";
import NavigationMenu from "@/components/NavigationMenu/NavigationMenu.vue";
import HeaderMainMenu from "@/components/HeaderMainMenu/HeaderMainMenu.vue";
import HeaderLanguageMenu from "@/components/HeaderLanguageMenu/HeaderLanguageMenu.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    NavigationMenu,
    HeaderLanguageMenu,
    HeaderMainMenu
  }
})
export default class AppHeaderMain extends Vue {
  @Getter("session/userLanguage")
  public userLanguage!: () => string;

  public isMainMenuShown = false;
  public isLangSelectShown = false;

  private getFlag() {
    const language = this.userLanguage();
    return getCountryFlagUrl(language === "en" ? "gb" : language);
  }

  public openMenu(name: "language" | "main") {
    this.isMainMenuShown = false;
    this.isLangSelectShown = false;

    switch (name) {
      case "language":
        this.isLangSelectShown = !this.isLangSelectShown;
        break;
      case "main":
        this.isMainMenuShown = !this.isMainMenuShown;
        break;
    }
  }
}
